export function onlyUnique(value: any, index: number, self: any[]) {
  return self.indexOf(value) === index;
}

export const ensureArray = <T>(t?: T[] | T | null): T[] => {
  if (!t) {
    return [];
  }
  if (Array.isArray(t)) {
    return t;
  }
  return [t];
};
